import "./testimonials.scss";

// const mehboobTitle = 

export default function Testimonials() {
    const data = [
        {
            id: 1,
            name: "Mahboob Ahmed",
            title: "CEO of Affinity Devs",
            img:
                "assets/Mahboob.jpeg",
            icon: "assets/linkedin.png",
            desc:
                " Khursheed's outstanding communication skills and ability to deliver the project ahead of time impressed me. I wholeheartedly recommend his services!",
        },
        {
            id: 2,
            name: "Irfan ",
            title: "Senior Unity Developer",
            img:
                "assets/Irfan.jpg",
            icon: "assets/linkedin.png",
            desc:
                "Khursheed's expertise was pivotal in achieving the success of our project. His unparalleled attention to detail and exceptional problem-solving skills made the collaboration truly enjoyable.  ",
            featured: true,
        },
        {
            id: 3,
            name: "Huzaifa Fiaz",
            title: "Senior React Developer",
            img:
                "assets/Huzaifa.jpg",
            icon: "assets/linkedin.png",
            desc:
                "Khursheed is a reliable professional who consistently delivers high-quality work. His efficiency and dedication make him a valuable asset to any project.",
        },
    ];
    return (
        <div className="testimonials" id="testimonials">
            <h1>Testimonials</h1>
            <div className="container">
                {data.map((d) => (
                    <div className={d.featured ? "card featured" : "card"}>
                        <div className="top">
                            <img src="assets/right-arrow.png" className="left" alt="" />
                            <img
                                className="user"
                                src={d.img}
                                alt=""
                            />
                            <img className="right" src={d.icon} alt="" />
                        </div>
                        <div className="center">
                            {d.desc}
                        </div>
                        <div className="bottom">
                            <h3>{d.name}</h3>
                            <h4>{d.title}</h4>
                            <h4 className="title">{`${(d.id === 1) ? "Project Manager at Teamstar" : ""}`}</h4>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}